import React from 'react';
import { useStore } from '../../store/useStore';
import { ClassSelector } from './ClassSelector';

export const StartScreen: React.FC = () => {
    const { setGameStarted } = useStore();

    const handleStartGame = () => {
        setGameStarted(true);
    };

    return (
        <div 
            onMouseDown={(e) => e.stopPropagation()} 
            onTouchStart={(e) => e.stopPropagation()}
            style={{
            position: 'fixed',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10000,
            background: 'linear-gradient(180deg, rgba(0,0,0,0.6), rgba(0,0,0,0.8))',
            pointerEvents: 'auto'
        }}>
            <div style={{
                width: '640px',
                maxWidth: '92%',
                background: 'rgba(10,10,15,0.85)',
                borderRadius: '12px',
                padding: '24px',
                boxShadow: '0 8px 30px rgba(0,0,0,0.6)',
                color: 'white',
                display: 'flex',
                gap: '20px',
                alignItems: 'center',
                justifyContent: 'space-between'
            }}>
                <div style={{ flex: 1 }}>
                    <h1 style={{ margin: 0, fontSize: '28px', letterSpacing: '2px' }}>Welcome to the World</h1>
                    <p style={{ color: '#ccc' }}>Select your class and press Start to enter the world.</p>

                    <div style={{ marginTop: '18px', display: 'flex', justifyContent: 'center' }}>
                        <ClassSelector inline />
                    </div>

                    <div style={{ marginTop: '18px' }}>
                        <button onClick={handleStartGame} style={{
                            padding: '12px 20px',
                            borderRadius: '8px',
                            background: '#00ffff',
                            color: '#000',
                            fontWeight: '700',
                            border: 'none',
                            cursor: 'pointer'
                        }}>Start Game</button>
                    </div>
                </div>

                <div style={{ width: '220px', textAlign: 'center' }}>
                    {/* Placeholder image - use existing asset or SVG */}
                    <img src="/vite.svg" alt="logo" style={{ width: '160px', height: '160px', objectFit: 'contain' }} />
                </div>
            </div>
        </div>
    );
};
